import Pace from 'pace-js';
import gsap from "gsap";

// Menu
/**
 * Botão para mostrar e esconder menu mobile
 * @type HTMLButtonElement
 */
const mobileButton = document.querySelector('.main_nav__content__mobile_btn');

/**
 * Botão para mostrar e esconder menu mobile
 * @type HTMLDivElement
 */
const menu = document.getElementById('menu-principal');

/**
 * Overlay que esconde os demais itens da página quando o menu estiver aberto
 * @type HTMLDivElement
 */
const menuOverlay = document.querySelector('.main_nav__overlay');

mobileButton.addEventListener('click', function (evt) {
    if (menu.clientHeight === 0) {
        // Menu fechado
        gsap.to(menu, {
            height: 'auto',
            duration: 0.3
        });

        mobileButton.classList.add('active');
        jQuery(menuOverlay).fadeIn(300);
    } else {
        // Menu aberto
        gsap.to(menu, {
            height: 0,
            duration: 0.3
        });

        mobileButton.classList.remove('active');
        jQuery(menuOverlay).fadeOut(300);
    }
});

menu.querySelectorAll('.menu-item-has-children').forEach(/** HTMLLinkElement */menuItem => {
    menuItem.addEventListener('click', function () {
        if (getComputedStyle(mobileButton).display === 'block') {
            /**
             * @type {HTMLUListElement}
             */
            const submenu = menuItem.querySelector('.sub-menu');

            if (submenu.clientHeight === 0) {
                // Menu fechado
                gsap.to(submenu, {
                    height: 'auto',
                    duration: 0.3
                });

                menuItem.classList.add('active');
            } else {
                // Menu aberto
                gsap.to(submenu, {
                    height: 0,
                    duration: 0.3
                });

                menuItem.classList.remove('active');
            }
        }
    });
});